<template>

  <svg viewBox="0 0 1080 1080">
    <switch>
      <g i:extraneous="self">
        <path
          d="M1034.48,549.02L711.86,602.8c-6.67,1.09-9.87,8.83-5.94,14.31l62.17,87.03c3.69,5.17,11.43,5.14,14.99-0.12
			c12.3-18.17,22.61-37.79,30.64-58.53c1.6-4.15,6.02-6.48,10.36-5.55l53.61,11.26c5.43,1.14,8.61,6.84,6.72,12.06
			c-14.87,41.58-37.07,79.66-65.01,112.72l76.63,107.29c6.02,8.42-4.34,18.78-12.74,12.76l-107.31-76.63
			c-32.97,27.87-70.95,50.02-112.41,64.91c-5.36,1.92-11.18-1.48-12.13-7.13l-9.07-54.43c-0.7-4.2,1.58-8.39,5.55-9.97
			c19.87-7.88,38.67-17.88,56.13-29.72c5.24-3.54,5.26-11.28,0.12-14.97l-87.06-62.17c-5.48-3.93-13.22-0.73-14.31,5.94
			l-53.78,322.62c-0.85,5.09-4.95,7.64-9.02,7.64c-4.08,0-8.17-2.55-9.02-7.64l-53.75-322.62c-1.12-6.67-8.83-9.87-14.34-5.94
			l-87.06,62.17c-5.14,3.69-5.12,11.43,0.12,14.97c17.47,11.84,36.29,21.83,56.13,29.72c3.98,1.58,6.26,5.77,5.55,9.97l-9.07,54.43
			c-0.95,5.65-6.77,9.05-12.13,7.13c-41.46-14.89-79.44-37.04-112.41-64.91l-107.29,76.63c-8.42,6.02-18.78-4.34-12.76-12.76
			l76.63-107.29c-27.94-33.06-50.14-71.15-65.01-112.72c-1.89-5.22,1.29-10.92,6.72-12.06l53.61-11.26
			c4.34-0.92,8.76,1.41,10.36,5.55c8.03,20.74,18.34,40.36,30.64,58.53c3.57,5.26,11.3,5.29,14.99,0.12l62.17-87.03
			c3.93-5.48,0.73-13.22-5.94-14.31L45.52,549.02c-10.19-1.7-10.19-16.35,0-18.05l322.62-53.78c6.67-1.09,9.87-8.83,5.94-14.31
			l-62.17-87.03c-3.69-5.17-11.43-5.14-14.99,0.12c-12.98,19.16-23.72,39.9-31.92,61.9c-1.53,4.1-5.75,6.48-10.04,5.77l-54.26-9.05
			c-5.58-0.92-8.98-6.65-7.16-12.01c14.87-43.86,37.82-83.95,67.07-118.57l-76.63-107.29c-6.02-8.42,4.34-18.78,12.76-12.76
			l107.29,76.63c32.31-27.34,69.45-49.15,109.93-64.01c5.39-1.99,11.26,1.43,12.2,7.08l9.1,54.55c0.68,4.2-1.58,8.34-5.51,9.95
			c-23.04,9.39-44.66,21.61-64.38,36.26l97.51,69.64c5.51,3.93,13.22,0.73,14.34-5.94l53.75-322.62c0.85-5.09,4.95-7.64,9.02-7.64
			c4.08,0,8.17,2.55,9.02,7.64l53.78,322.62c1.09,6.67,8.83,9.87,14.31,5.94l97.51-69.64c-19.72-14.65-41.33-26.88-64.38-36.26
			c-3.93-1.6-6.19-5.75-5.51-9.95l9.1-54.55c0.95-5.65,6.82-9.07,12.2-7.08c40.49,14.87,77.62,36.68,109.93,64.01l107.31-76.63
			c8.39-6.02,18.75,4.34,12.74,12.76l-76.63,107.29c29.25,34.61,52.23,74.71,67.07,118.57c1.82,5.36-1.58,11.09-7.16,12.01
			l-54.26,9.05c-4.29,0.7-8.51-1.67-10.04-5.77c-8.2-22-18.94-42.74-31.92-61.9c-3.57-5.26-11.3-5.29-14.99-0.12l-62.17,87.03
			c-3.93,5.48-0.73,13.22,5.94,14.31l322.62,53.78C1044.67,532.67,1044.67,547.33,1034.48,549.02z"
        />
      </g>
    </switch>
  </svg>


</template>